import * as React from "react"
import { observer } from "mobx-react"
import { LinkContainer } from "react-router-bootstrap"
import * as H from "history"
import { Button } from "reactstrap"
import BaseView from "../BaseView"
import { route } from "../../routes/routes"
import { Routes } from "../../routes/AppRoutes"
import { ApiTableViewAdapter } from "../../components/table-view/ApiTableViewAdapter"
import { QueryWhereClause } from "../../api/ApiClient"
import { ManagedChooseableColumn } from "../../components/table-view/ManagedTableViewColumnChooser";
import ManagedTableView from "../../components/table-view/ManagedTableView";
import DateFilter from '../../components/table-view/filters/DateFilter'
import { Link } from 'react-router-dom'
import { formatDateForCalendar } from '../../common/Util'
import AuthStore from '../../stores/AuthStore'
import BoardTraining from "../../models/BoardTraining"

type Props = {
  location: H.Location<H.LocationState>,
}

@observer
export default class BoardTrainingsView extends BaseView<Props> {
  renderContentHeader (): React.ReactNode | null {
    return (
      <>
        <h1>Board Trainings</h1>
        <ul className="content-header-actions">
          <li>
            <LinkContainer to={route(Routes.system.boardTraining.create)}>
              <Button color="primary" onClick={() => {
              }}><i className="fa fa-plus-circle"/> Add New Board Training</Button>
            </LinkContainer>
          </li>
        </ul>
      </>
    )
  }

  private tableViewRef = React.createRef<ManagedTableView>()

  private availableColumns: ManagedChooseableColumn[] = [
    {
      id: 'date',
      column: {
        accessor: 'date',
        title: 'Date',
        renderItem: (d, boardTraining) => <Link to={route(Routes.system.boardTraining.detail, {id: boardTraining.id})}>{d.clone().tz(boardTraining.timezone).format('dddd, MMMM Do')} @ {formatDateForCalendar(d, boardTraining.timezone, AuthStore.getUser()!.timezone || 'UTC', false)}{boardTraining.cancelledAt ? ` (Cancelled)` : null}</Link>,
        sortable: true,
      },
      default: true,
    },
    {
      id: 'numberOfMembers',
      column: {
        accessor: 'numberOfMembers',
        title: 'Members',
        sortable: true,
      },
      fixed: true,
    },
  ]

  private boardTrainingAdapter = new ApiTableViewAdapter(() => {
      const where: QueryWhereClause[] = []

      return {
        query: `
        boardTrainings {
        *
      }
    `,
        where: where,
      }
    },
    'boardTrainings',
    BoardTraining
  )

  renderContentBody (): React.ReactNode {
    return this.renderTable()
  }

  private filters = [
    new DateFilter('date', 'date', 'Date Scheduled'),
  ]

  private renderTable = () => {
    return <ManagedTableView
      stateKey="BoardTrainingView"
      hideItemCount={true}
      showSearch={false}
      alwaysShowFilters={true}
      filters={this.filters}
      allowShowInactive={false}
      ref={this.tableViewRef}
      adapter={this.boardTrainingAdapter}
      availableColumns={this.availableColumns}
      defaultSort={{sortKey: 'date', descending: true}}
    />
  }
}
